import React from 'react'
import ReactLoading from 'react-loading'

export default function Loading(): JSX.Element {
  return <ReactLoading color="blue" type="bars" />
}
